<section class="default-loader" [className]="customClass" [ngStyle]="{'background-color': isFromTemplateForm ? '#a9a9a936' : '#00000036'}">
    <mat-spinner class="cst-spinner" [diameter]="spinnerDiameter"></mat-spinner>
</section>